import { API } from 'const';
import queryFormatter from 'helpers/queryFormatter';
import { put, takeEvery, call } from 'redux-saga/effects';
import api from 'services/api';
import meridianTypes from './meridian.types';

export function* getMeridianClients(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() => api.get(`${API.MERIDIAN}/clients?${queryFormatter(data.params)}`));
    if (res.status === 200) {
      yield put({ type: meridianTypes.SET_MERIDIAN_CLIENTS, payload: res.data.data });
      cb(res.data.data);
    }
  } catch (err) {
    const { cbError } = action;
    cbError(err?.response?.data?.message || '');
  }
}

export function* getMeridianClientDetails(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() => api.get(`${API.MERIDIAN}/clients/${data.id}`));
    if (res.status === 200) {
      yield put({ type: meridianTypes.SET_MERIDIAN_CLIENT_DETAILS, payload: res.data.data });
      cb(res.data.data);
    }
  } catch (err) {
    const { cbError } = action;
    cbError(err?.response?.data?.message || '');
  }
}

export function* activateMeridianClient(action) {
  try {
    const { cb, payload: data } = action;
    const res = yield call(() => api.patch(`${API.MERIDIAN}/clients/${data.id}/activate`));
    if (res.status === 200) {
      cb(res.data.data);
    }
  } catch (err) {
    const { cbError } = action;
    cbError(err?.response?.data?.message || '');
  }
}

function* watchMeridianSaga() {
  yield takeEvery(meridianTypes.GET_MERIDIAN_CLIENTS, getMeridianClients);
  yield takeEvery(meridianTypes.GET_MERIDIAN_CLIENT_DETAILS, getMeridianClientDetails);
  yield takeEvery(meridianTypes.ACTIVATE_MERIDIAN_CLIENT, activateMeridianClient);
}

export default watchMeridianSaga;
